export type TourProgressDot = {
  /** Index in the full step list this slot represents. */
  stepIndex: number;
  /** True when this slot is the current tour step. */
  active: boolean;
  /**
   * True for the first/last window slot when more steps exist outside the window —
   * render smaller/fainter to hint at continuation.
   */
  truncated: boolean;
};

/**
 * Sliding window of progress dots so the footer stays compact.
 * Active step stays in-window (centered when possible); edge slots mark overflow.
 */
export function tourProgressDots(
  stepIndex: number,
  stepCount: number,
  windowSize = 5,
): TourProgressDot[] {
  if (stepCount <= 0) return [];
  const size = Math.max(1, Math.min(windowSize, stepCount));
  const clampedIndex = Math.min(Math.max(stepIndex, 0), stepCount - 1);

  let start = clampedIndex - Math.floor(size / 2);
  start = Math.max(0, Math.min(start, stepCount - size));

  const dots: TourProgressDot[] = [];
  for (let i = 0; i < size; i += 1) {
    const idx = start + i;
    const truncated =
      (i === 0 && start > 0) || (i === size - 1 && start + size < stepCount);
    dots.push({
      stepIndex: idx,
      active: idx === clampedIndex,
      truncated,
    });
  }
  return dots;
}
